<template>
  <div id="app">
    <!-- <common-title @showMenu="toggleMenu"></common-title> -->
    <div class="content">
      <keep-alive include="Serve,College,Activity">
        <router-view />
      </keep-alive>
    </div>
  </div>
</template>

<script>
// import { selectAsyncTree } from "@/api/attest";
export default {
  components: {},
  data() {
    return {
      userInfo: {},
      // addrssData: [],
      showMenu: false,
    };
  },
  methods: {
    // getAddress() {
    //   selectAsyncTree()
    //     .then((res) => {
    //       localStorage.setItem("addrssData", JSON.stringify(res.data));
    //     })
    //     .catch(() => {});
    // },
  },
  mounted() {
    // this.getAddress();
  },
};
</script>

<style lang="less">
#app {
  position: relative;
  width: 100%;
  height: 100%;
  background: #fff;
  .content {
    width: 100%;
    height: 100%;
  }
  .menu {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    z-index: 100;
    color: @white;
    letter-spacing: 2px;
    font-size: @l-font-size;
    text-align: center;
    background-color: #454648cc;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    &_item {
      padding: 20px 12px;
      margin: 35px 0;
      position: relative;
      &.active {
        color: @green;
        &::before,
        &::after {
          content: "";
          display: block;
          position: absolute;
          width: 12px;
          height: 12px;
        }
        &::before {
          left: 0;
          top: 0;
          border-style: solid;
          border-width: 2px 0 0 2px;
          border-color: @green;
        }
        &::after {
          right: 0;
          bottom: 0;
          border-style: solid;
          border-width: 0 2px 2px 0;
          border-color: @green;
        }
      }
    }
    &-close {
      text-align: right;
      position: absolute;
      right: 28px;
      top: 28px;
      &-img {
        width: 20px;
        height: 16px;
      }
    }
  }
}
</style>
